module.exports = __webpack_public_path__ + "img/椭圆点.3ceb9693.png";